
import { Base } from '../base-component';
import './deals-feature.component.scss';

export class DealsFeature extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}
}


// WEBPACK FOOTER //
// ./components/deals-feature/deals-feature.component.ts